import * as yup from 'yup';
import { StrOrNum } from '../../types/util';
import { googleMapAddressValidations } from '../../utils/validation';

export const qualificationInputValidationSchema = yup.object().shape({
  educationLevel: yup.string().required('Please select your education level'),
  institute: yup.string().required('Please select the education board or university'),
  graduatedYear: yup.string().required('Please select the year you passed out'),
  percentage: yup.lazy((value: StrOrNum) => {
    return value.toString().trim().length === 0
      ? yup.string()
      : yup
          .number()
          .typeError('Please enter a valid percentage')
          .min(0, 'Percentage cannot be less than 0')
          .max(100, 'Percentage cannot be greater than 100');
  }),
  GPA: yup.lazy((value: StrOrNum) => {
    return value.toString().trim().length === 0
      ? yup.string()
      : yup
          .number()
          .optional()
          .typeError('Please enter a valid GPA')
          .min(0, 'GPA cannot be less than 0')
          .max(4, 'GPA cannot be greater than 4');
  }),
  rank: yup.string().when(['GPA', 'percentage'], {
    is: (GPA: string | undefined | number, percentage: string | undefined | number) => {
      if (!GPA && !percentage) return true;
      if (GPA && GPA.toString().length === 0 && percentage && percentage.toString().length === 0) return true;
      return false;
    },
    then: yup.string().required('Grade level is required when percentage or GPA is not present'),
  }),
  faculty: yup.string().notRequired(),
  course: yup.array(yup.string()).notRequired(),
});

export const qualificationInputWithAddressValidationSchema = qualificationInputValidationSchema.concat(
  yup.object({
    address: googleMapAddressValidations.location,
    address_lat: googleMapAddressValidations.lat,
    address_lng: googleMapAddressValidations.lng,
  })
);
